import { TooltipPositioningOption as FluentTooltipPositioningOption } from "@fluentui/web-components";
/** Positioning values for {@link Tooltip}. */
export const TooltipPositioningOptions = {
    ...FluentTooltipPositioningOption
};
//# sourceMappingURL=tooltip.options.js.map